/* eslint-disable react-hooks/exhaustive-deps */
import { useFormikContext } from "formik";
import React, { useEffect } from "react";

import {
	AcquisitionOptions,
	AcquisitionTypes,
	AssetsTypesOptions,
	StockAssetsTypes
} from "../../../../config/filingConstants";
import { IStocksForm } from "../../../../config/interfaces";
import { UtilService } from "../../../../services";
import { FormField, NumericInputField, SelectInputField, TextInputField } from "../../../fields";

type Props = {};

const CGStocksForm: React.FC<Props> = (props: Props) => {
	const {} = props;

	const { values, errors, touched, setFieldValue, handleBlur, setFieldTouched } =
		useFormikContext<IStocksForm>();

	useEffect(() => {
		const _TotalSale = Number(values?.SalePrice || 0) - Number(values.TransferExpense || 0);
		setFieldValue("TotalSaleConsideration", _TotalSale);
		const _CapitalGain = _TotalSale - Number(values?.TotalCostAcquisition || 0);
		setFieldValue("CapitalGains", _CapitalGain);
	}, [values?.TotalCostAcquisition, values?.SalePrice, values.TransferExpense]);

	return (
		<>
			<section className="mb-5">
				<FormField label="Type of Assets" isRequired={true} sm={4}>
					<SelectInputField
						placeholder="Type of Assets"
						name="TypeAssets"
						options={UtilService.convertToArray(AssetsTypesOptions)}
						value={
							values.TypeAssets
								? [{ label: AssetsTypesOptions[values.TypeAssets], value: values.TypeAssets }]
								: undefined
						}
						onChange={(_selectedTypesAssets) => {
							if (_selectedTypesAssets) {
								if (
									[
										StockAssetsTypes.Listed_Long_10_Per,
										StockAssetsTypes.Listed_Short_15_Per
									].includes(_selectedTypesAssets.value)
								) {
									setFieldValue("STTPaid", "Yes");
								} else {
									setFieldValue("STTPaid", "No");
									setFieldValue("TotalFairMarketValue", "");
								}
								setFieldValue("Acquisition", undefined);
								setFieldValue("NameOfShare", "");
								setFieldValue("ISINCode", "");
								setFieldValue("TypeAssets", _selectedTypesAssets.value);
							} else {
								setFieldValue("TypeAssets", undefined);
							}
						}}
						onBlur={handleBlur("TypeAssets")}
						isInvalid={Boolean(errors.TypeAssets) && touched.TypeAssets}
						errorMsg={errors.TypeAssets}
					/>
				</FormField>
				{values.TypeAssets === StockAssetsTypes.Listed_Long_10_Per ? (
					<>
						<FormField label="Share acquired" sm={4}>
							<SelectInputField
								placeholder="Share acquired"
								name="Acquisition"
								options={UtilService.convertToArray(AcquisitionOptions)}
								value={
									values.Acquisition
										? [{ label: AcquisitionOptions[values.Acquisition], value: values.Acquisition }]
										: undefined
								}
								onChange={(_selectedAcquisition) => {
									if (_selectedAcquisition) {
										setFieldValue("Acquisition", _selectedAcquisition.value);
										if (_selectedAcquisition.value === AcquisitionTypes.After_31_01_2018) {
											setFieldValue("ISINCode", "INNOTREQUIRD");
											setFieldValue("NameOfShare", "CONSOLIDATED");
											setFieldTouched("ISINCode", false);
											setFieldTouched("NameOfShare", false);
										} else {
											setFieldValue("ISINCode", "");
											setFieldValue("NameOfShare", "");
										}
									} else {
										setFieldValue("Acquisition", undefined);
									}
								}}
								onBlur={handleBlur("Acquisition")}
								isInvalid={Boolean(errors.Acquisition) && touched.Acquisition}
								errorMsg={errors.Acquisition}
								isDisabled={values.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per}
							/>
						</FormField>

						<FormField label="ISIN Code" sm={4}>
							<TextInputField
								name="ISINCode"
								value={values.ISINCode}
								onChange={(value) => {
									setFieldValue("ISINCode", value);
								}}
								onBlur={(e) => {
									handleBlur(e);
									setFieldValue("ISINCode", values.ISINCode.trim());
								}}
								isInvalid={Boolean(errors.ISINCode) && touched.ISINCode}
								errorMsg={errors.ISINCode}
								isDisabled={
									values.Acquisition === AcquisitionTypes.After_31_01_2018 ||
									values.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per
								}
							/>
						</FormField>
						<FormField label="Name of Share" sm={4}>
							<TextInputField
								name="NameOfShare"
								value={values.NameOfShare}
								onChange={(value) => {
									setFieldValue("NameOfShare", value);
								}}
								onBlur={(e) => {
									handleBlur(e);
									setFieldValue("NameOfShare", values.NameOfShare.trim());
								}}
								isInvalid={Boolean(errors.NameOfShare) && touched.NameOfShare}
								errorMsg={errors.NameOfShare}
								isDisabled={
									values.Acquisition === AcquisitionTypes.After_31_01_2018 ||
									values.TypeAssets !== StockAssetsTypes.Listed_Long_10_Per
								}
							/>
						</FormField>
					</>
				) : null}

				{/* Total of Sell value under long term */}
				<FormField label="Full value of consideration" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="SalePrice"
						value={values.SalePrice}
						onChange={(value) => {
							setFieldValue("SalePrice", value);
						}}
						onBlur={handleBlur("SalePrice")}
						isInvalid={Boolean(errors.SalePrice) && touched.SalePrice}
						errorMsg={errors.SalePrice}
					/>
				</FormField>

				<FormField label="Transfer Expenses" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="TransferExpense"
						value={values.TransferExpense}
						onChange={(value) => {
							setFieldValue("TransferExpense", value);
						}}
						onBlur={handleBlur("TransferExpense")}
						isInvalid={Boolean(errors.TransferExpense) && touched.TransferExpense}
						errorMsg={errors.TransferExpense}
					/>
				</FormField>

				<FormField label="Total Sale Consideration" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						name="TotalSaleConsideration"
						value={values.TotalSaleConsideration}
						onChange={(value) => {
							const CapitalGainsValue = Number(value) - Number(values.TotalCostAcquisition || 0);
							setFieldValue("TotalSaleConsideration", value);
							setFieldValue("CapitalGains", CapitalGainsValue);
						}}
						onBlur={handleBlur("TotalSaleConsideration")}
						isInvalid={Boolean(errors.TotalSaleConsideration) && touched.TotalSaleConsideration}
						errorMsg={errors.TotalSaleConsideration}
						isDisabled={true}
					/>
				</FormField>

				<FormField label="Total Fair Market Value" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						name="TotalFairMarketValue"
						value={values.TotalFairMarketValue}
						onChange={(value) => {
							setFieldValue("TotalFairMarketValue", value);
						}}
						onBlur={handleBlur("TotalFairMarketValue")}
						isInvalid={Boolean(errors.TotalFairMarketValue) && touched.TotalFairMarketValue}
						errorMsg={errors.TotalFairMarketValue}
					/>
				</FormField>

				{/* Total of buy value under long term */}
				<FormField label="Total cost of Acquisition" sm={4} isRequired={true}>
					<NumericInputField
						showLeftIcon={true}
						name="TotalCostAcquisition"
						value={values.TotalCostAcquisition}
						onChange={(value) => {
							const CapitalGainsValue = Number(values.TotalSaleConsideration || 0) - Number(value);
							setFieldValue("TotalCostAcquisition", value);
							setFieldValue("CapitalGains", CapitalGainsValue);
						}}
						onBlur={handleBlur("TotalCostAcquisition")}
						isInvalid={Boolean(errors.TotalCostAcquisition) && touched.TotalCostAcquisition}
						errorMsg={errors.TotalCostAcquisition}
					/>
				</FormField>

				<FormField label="Capital Gains/(Loss)" sm={4}>
					<NumericInputField
						showLeftIcon={true}
						placeholder=""
						name="CapitalGains"
						allowNegative={true}
						value={values.CapitalGains}
						onChange={(value) => setFieldValue("CapitalGains", value)}
						onBlur={handleBlur("CapitalGains")}
						isInvalid={Boolean(errors.CapitalGains) && touched.CapitalGains}
						errorMsg={errors.CapitalGains}
						isDisabled={true}
					/>
				</FormField>
			</section>
		</>
	);
};

export default CGStocksForm;
